import './src/vaadin-tooltip.js';

export * from './src/vaadin-tooltip.js';
